import { apolloClient } from '~/apollo-client';
import {
  Flex_UpdateUserPreferencesMutation,
  Flex_UpdateUserPreferencesMutationVariables,
} from '~/typings/graphql';
import { UPDATE_USER_PREFERENCES } from './update-user-preferences.queries';

export interface UpdateUserPreferencesParams {
  enabledGoogleSignIn: boolean;
  userId: number;
}

export type UpdateUserPreferencesResponse = void;

export const updateUserPreferences = async (
  params: UpdateUserPreferencesParams,
): Promise<UpdateUserPreferencesResponse> => {
  await apolloClient.mutate<
    Flex_UpdateUserPreferencesMutation,
    Flex_UpdateUserPreferencesMutationVariables
  >({
    mutation: UPDATE_USER_PREFERENCES,
    variables: {
      input: {
        enabledGoogleSignIn: params.enabledGoogleSignIn,
        id: params.userId,
      },
    },
  });
};
